export default {
  skip_to_main_content: 'Hoppa till huvudinnehåll',
  show_system_messages: 'Visa systemmeddelanden',
  dont_show_system_messages: 'Dölj systemmeddelanden',
  logged_in: 'Hyresgäst är verifierad',
  logged_out: 'Anonym användare',
  button_tooltip_switch_locale: 'Ändra språk',
  button_tooltip_activate_voice_recognition: 'Aktivera röstigenkänning',
  date_input: 'Välj datum',
  choose_two_dates: 'Välj två datum',
  date_range: 'Datumintervall',
  from: 'från',
  to: 'till',
  avatar: 'Avatar',
  exit: 'Avsluta',
  new: 'Ny',
  back: 'Tillbaka',
  address: 'Adress',
  suggestions: 'Förslag',
  senton: 'Skickat den',
  message_placeholder: 'Skriv meddelande här',
  message_aria: 'Skriv meddelande här',
  upload_in_progress: 'Uppladdning pågår...',
  comment_placeholder: 'Skriv kommentar här',
  message_button_label: 'Skicka',
  please_confirm: 'Bekräfta',
  no: 'Nej',
  yes: 'Ja',
  modal_delete_session: 'Radera session',
  modal_delete_session_notification:
    'Om du stänger fönstret, kommer din session att raderas. <br>Är du säker?',
  template_contact_time: 'När kan vi kontakta dig?',
  template_pause:
    'Din session har pausats. En av vår supportpersonal kommer att ta hand om din förfrågan inom kort.',
  template_continue_after_pause:
    'Din session har återupptagits. Du kan du fortsätta skriva till vår chattrobot.',
  choose_date: 'Välj ett datum',
  button_apply: 'Tillämpa',
  button_cancel: 'Avbryt',
  none: 'Ingen',
  book_appointment: 'Boka möte',
  address_input: 'Adress',
  data_processing: 'Databehandling',
  privacy_policy: 'Integritetspolicy',
  data_processing_notification_before_link:
    'För att använda denna chatt-tjänst måste du acceptera ',
  data_processing_notification_after_link: '.',
  button_accept: 'Acceptera',
  select_date: 'Välj datum',
  rate_conversation: 'Hur skulle du betygsätta denna konversation?',
  new_ticket_question: 'Är det något annat jag kan hjälpa till med?',
  thank_you:
    'Tack för din support. Din feedback hjälper mig att ständigt förbättra mig själv.',
  goodbye: 'Hej då.',
  start_new: 'Starta ny konversation',
  operator_entered_the_chat: 'Operatör kom in i chatten',
  operator_left_the_chat: 'Operatör har lämnat chatten',
  bg_image: process.env.VUE_APP_SV_BG,
  expand_quickreplies: 'Mer',
  collapse_quickreplies: 'Färre',
  login: 'Logga in',
  logout: 'Logga ut',
  close: 'Stäng',
  messenger_text: 'Du kan antingen skriva med vår chatbot eller kontakta en av våra anställda direkt i vår livechatt.',
  chat_bot: 'Chat Bot',
  live_bot: 'Live Chat',
  maximize: 'Maximera',
  minimize: 'Minimera',
  upload_file: 'Släpp filen här för att ladda upp',
  upload_file_or: 'eller',
  Upload_file_select: 'Lägg till filer',
  upload_file_text: 'Släpp fil för att ladda upp',
  show_attachments: 'Visa bilaga',
  hide_attachments: 'Dölj bilaga',
  tooBig: 'Filen är för stor',
  tooSmall: 'Filen är för liten',
  invalidFileTypeCopilot:
    'Ogiltig filtyp. För närvarande stöds endast filtyperna .png, .jpg, .jpeg, .gif.',
  tooManyFiles: 'Ladda upp maximalt 5 filer samtidigt',
  chatProtocol: 'ProtokollFörChatt',
  showMore: 'Visa mer',
  showLess: 'Visa mindre',
  uploadTooltip: 'Ladda upp en fil',
  uploadFilesTooltip: 'Ladda upp filer',
  pdfDownloadTooltip: 'Ladda ner konversation',
  feedbackDescription: 'Feedback till oss',
  feedbackPlaceholder: 'Ange ditt meddelande här...',
  feedbackInfoPlaceholder: 'Lägg gärna till specifika detaljer...',
  feedbackSubtitle: {
    description:
      'Här kan du skicka oss allmänna förslag, förslag och önskemål.',
    note: 'Observera att vi inte kan svara på dem.',
    hint:
      'Alla andra frågor som specifikt rör din hyresrätt eller sökandet efter en lägenhet kan du beskriva för oss i chatten.'
  },
  sendFeedback: 'Skicka',
  giveFeedback: 'Feedback till oss',
  feedbackSubmittedSuccessfully: 'Ditt feedback har skickats framgångsrikt',
  character_limit: 'Tecken',
  page: 'p.',
  factually_incorrect: 'Inte faktiskt korrekt',
  not_following_instructions: 'Har inte följt instruktionerna fullständigt',
  info_not_in_document: 'Efterfrågad information inte i dokumentet',
  inappropriate_or_offensive: 'Olämplig eller kränkande',
  irrelevant: 'Irrelevant',
  not_fitting_topic: 'Passar inte ämnet',
  confusing_information: 'Förvirrande information',
  ignored_important_parts_of_document: 'Ignorerade viktiga delar av dokumentet',
  interpreted_document_wrong: 'Dokumentet tolkat fel',
  answer_to_generic: 'Svar för generellt',
  sources_incorrect: 'Källor opålitliga eller felciterade',
  why_not_helpful: 'Varför var detta inte till hjälp?',
  thank_you_feedback: 'Tack för din feedback!',
  provide_feedback: 'Ge feedback på svaret',
  not_helpful: 'Inte till hjälp',
  helpful: 'Till hjälp',
  regenerate_message: 'Generera om',
  copy_message: 'Kopiera',
  copied_message: 'Kopierat!',
  original_answer: 'Ursprungligt svar',
  regenerated_answer: 'Regenererat svar',
  thinking_message: 'Jag tänker...',
  file_path: 'Filsökväg: ',
  new_messages: 'Nya meddelanden',
  previous_message: 'Föregående meddelande',
  next_message: 'Nästa meddelande',
  clear_input: 'Rensa inmatning',
  open_feedback: 'Öppna feedback',
  file_upload: 'Filuppladdning',
  expand_quickreplies_aria: 'Visa fler knappar',
  button_tooltip_switch_locale_german: 'Ändra språk till tyska',
  button_tooltip_switch_locale_french: 'Ändra språk till franska',
  button_tooltip_switch_locale_dutch: 'Ändra språk till holländska',
  button_tooltip_switch_locale_turkish: 'Ändra språk till turkiska',
  button_tooltip_switch_locale_russian: 'Ändra språk till ryska',
  button_tooltip_switch_locale_swedish: 'Ändra språk till svenska',
  button_tooltip_switch_locale_ukranian: 'Ändra språk till ukrainska',
  button_tooltip_switch_locale_spanish: 'Ändra språk till spanska',
  button_tooltip_switch_locale_polish: 'Ändra språk till polska',
  button_tooltip_switch_locale_arabic: 'Ändra språk till arabiska',
  button_tooltip_switch_locale_italian: 'Ändra språk till italienska',
  button_tooltip_switch_locale_english: 'Ändra språk till engelska',
  message_from_you: 'Du säger',
  message_from_bot: 'Bot säger',
  message_from_operator: 'Agent säger',
  new_message_from_bot: 'Bot säger',
  empty_message_received: 'Tomt meddelande mottaget'
}
